// src/pages/confirm/ActivationPage.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ActivationPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        // Parse the query parameters
        const queryParams = new URLSearchParams(location.search);
        const activationStatus = queryParams.get('activation');
        const email = queryParams.get('email');

        switch (activationStatus) {
            case 'success':
                setMessage(t('ActivationSuccess').split('\n'));
                break;
            case 'expired':
                setMessage(t('ActivationExpired').split('\n'));
                break;
            case 'invalid':
                setMessage(t('ActivationInvalid').split('\n'));
                break;
            case 'alreadyVerified':
                setMessage(t('ActivationAlreadyVerified').split('\n'));
                break;
            default:
                setMessage(t('ActivationDefault').split('\n'));
        }

        if (activationStatus === 'success' || activationStatus === 'alreadyVerified') {
            setTimeout(() => {
                navigate('/login');
            }, 5000);
        }
    }, [navigate, location.search, t]);

    return (
        <div className='confirm-container'>
            {Array.isArray(message) 
                ? message.map((line, idx) => <p key={idx} className="custom-confirm">{line}</p>)
                : <p className="custom-confirm">{message}</p>
            }
        </div>
    );
}

export default ActivationPage;
